<template>
  <transition
    name="el-message-fade"
    @after-leave="handleAfterLeave"
    @after-enter="handleAfterEnter"
  >
    <div
      :class="[
        'el-message',
        type && !iconClass ? `el-message--${type}` : '',
        center ? 'is-center' : '',
        showClose ? 'is-closable' : '',
        customClass,
        custom ? 'custom' : '',
      ]"
      :style="positionStyle"
      v-show="visible"
      @mouseenter="clearTimer"
      @mouseleave="startTimer"
      role="alert"
    >
      <div class="tips" v-if="custom"><i></i></div>
      <template v-else>
        <i :class="iconClass" v-if="iconClass"></i>
        <i :class="typeClass" v-else></i>
      </template>
      <slot>
        <p v-if="!dangerouslyUseHTMLString" class="el-message__content">
          {{ message }}
        </p>
        <p v-else v-html="message" class="el-message__content"></p>
      </slot>
      <i
        v-if="showClose"
        class="el-message__closeBtn el-icon-close"
        @click="close"
      ></i>
    </div>
  </transition>
</template>

<script type="text/babel">
const typeMap = {
  success: "success",
  info: "info",
  warning: "warning",
  error: "error",
};

export default {
  data() {
    return {
      visible: false,
      message: "",
      duration: 3000,
      type: "info",
      iconClass: "",
      customClass: "",
      onClose: null,
      showClose: false,
      closed: false,
      verticalOffset: 20,
      timer: null,
      dangerouslyUseHTMLString: false,
      center: false,
      custom: false,
      animateStatus: false,
    };
  },

  computed: {
    typeClass() {
      return this.type && !this.iconClass
        ? `el-message__icon el-icon-${typeMap[this.type]}`
        : "";
    },
    positionStyle() {
      return {
        top: `${this.verticalOffset}px`,
      };
    },
  },

  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false;
      }
    },
  },

  methods: {
    handleAfterLeave() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);

      this.animateStatus = false;
    },
    handleAfterEnter() {
      this.animateStatus = true;
    },
    close() {
      this.closed = true;
      if (typeof this.onClose === "function") {
        this.onClose(this);
      }
    },

    clearTimer() {
      clearTimeout(this.timer);
    },

    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close();
          }
        }, this.duration);
      }
    },
    keydown(e) {
      if (e.keyCode === 27) {
        // esc关闭消息
        if (!this.closed) {
          this.close();
        }
      }
    },
  },
  mounted() {
    this.startTimer();
    document.addEventListener("keydown", this.keydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keydown);
  },
};
</script>
<style lang="less">
.animate__rubberBand {
  animation-name: rubberBand1;
}
.animate__animated {
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  transform-origin: 0 50%;
  //animation-iteration-count:2;
  //animation-direction:alternate;
}
.el-message {
  z-index: 3000 !important;
  &.custom {
    display: block;
    max-width: 6.15rem;

    .tips {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 5px;
      i {
        display: block;
        width: 0.24rem;
        height: 0.24rem;
      }
      &:after {
        height: 0.24rem;
        line-height: 0.24rem;
        display: block;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 500;
        margin-left: 0.16rem;
      }
    }
    &.el-message--warning {
      background: #fffaeb;
      border: 1px solid rgba(255, 226, 141, 1);
      border-radius: 4px;
      .tips {
        i {
          background: url("@/assets/img/message/warning.svg") 0 0 no-repeat;
        }
        &:after {
          content: "警告！";
        }
      }
    }
    &.el-message--info {
      background: #edf5ff;
      border: 1px solid rgba(151, 195, 255, 1);
      border-radius: 4px;
      .tips {
        i {
          background: url("@/assets/img/message/info.svg") 0 0 no-repeat;
        }
        &:after {
          content: "信息！";
        }
      }
    }
    &.el-message--success {
      background: #edf5ff;
      border: 1px solid rgba(151, 195, 255, 1);
      border-radius: 4px;
      .tips {
        i {
          background: url("@/assets/img/message/success.svg") 0 0 no-repeat;
        }
        &:after {
          content: "成功！";
        }
      }
    }
    &.el-message--error {
      background: #fff0ef;
      border: 1px solid rgba(255, 171, 166, 1);
      border-radius: 4px;
      .tips {
        i {
          background: url("@/assets/img/message/error.svg") 0 0 no-repeat;
        }
        &:after {
          content: "错误！";
        }
      }
    }
    .el-message__content {
      margin-left: 0.4rem;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      line-height: 22px;
      font-weight: 400;
      border-bottom: none !important;
    }
    p {
      border-bottom: none;
    }
    .el-message__closeBtn {
      top: 15px;
    }
  }
}
@keyframes rubberBand1 {
  0% {
    transform: scale3d(1, 1, 1) translateX(-50%);
  }

  25% {
    transform: scale3d(1.25, 0.75, 1) translateX(-50%);
  }

  35% {
    transform: scale3d(0.75, 1.25, 1) translateX(-50%);
  }

  45% {
    transform: scale3d(1.15, 0.85, 1) translateX(-50%);
  }

  55% {
    transform: scale3d(0.95, 1.05, 1) translateX(-50%);
  }

  65% {
    transform: scale3d(1.05, 0.95, 1) translateX(-50%);
  }
  75% {
    transform: scale3d(0.95, 1.05, 1) translateX(-50%);
  }

  85% {
    transform: scale3d(1.05, 0.95, 1) translateX(-50%);
  }

  100% {
    transform: scale3d(1, 1, 1) translateX(-50%);
  }
}
//@keyframes  rubberBand1{
//
//0% {
//  transform: scale3d(1, 1, 1) translateX(-50%);
//}
//
//30% {
//  transform: scale3d(1.25, 0.75, 1) translateX(-50%);
//}
//
//40% {
//
//  transform: scale3d(0.75, 1.25, 1) translateX(-50%);
//}
//
//50% {
//
//  transform: scale3d(1.15, 0.85, 1) translateX(-50%);
//}
//
//65% {
//
//  transform: scale3d(0.95, 1.05, 1) translateX(-50%);
//}
//
//75% {
//
//  transform: scale3d(1.05, 0.95, 1) translateX(-50%);
//}
//
//100% {
//  transform: scale3d(1, 1, 1) translateX(-50%);
//  }
//}
</style>
